export default __webpack_public_path__ + "static/media/BANANA-TWT-BNB.4fc8f8e5.svg";